<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/index-banner.png`)})`}">
				<h2 class="banner-title">构建无信任边界的Web3安全生态</h2>
				<p class="banner-note">链启新生态 安全护未来</p>
				<p class="banner-info">践行“去中心化、责任、互信”的准则，探索“共研、共创、共守”的路径，打造无界可信的Web3技术安全共同体。</p>
			</div>

			<section class="module news-container">
				<div class="center70">
					<div class="module-title">
						<h2 class="title"> 行业新闻 <span class="en">NEWS</span> </h2>
					</div>
					<div class="news-view">
						<div class="news-banner">
							<img src="@/assets/images/news.png">
						</div>
						<div class="lately-new">
							<h3 class="lately-title">近期新闻</h3>
							<ul class="lately-news-list">
								<li v-for="(item, idx) in newsList" :key="idx" class="lately-new-item">
									<h4 class="new-title">
										<a :href='`/news/${item.id}`'>
											{{ item.title }}
										</a>
									</h4>
									<p class="new-date"> {{ item.publishedAt}} </p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section class="module technology-container" style="background-color: #f4f4f4;">
				<div class="center70">
					<div class="module-title">
						<h2 class="title">精选专题 <span class="en">TOPICS</span> </h2>
					</div>
					<div class="swiper-container technology-swiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(img,index) in bannerList"
									 :key="index" @click="toDetail(100 + index)" >
								<img :src="img.imgUrl" />
							</div>
						</div>
						<div class="swiper-button-next"></div>
						<div class="swiper-button-prev"></div>
					</div>
				</div>
			</section>

			<section class="module partner-container">
				<div class="center70">
					<div class="module-title">
						<h2 class="title">技术 <span class="en">TECHNOLOGY</span> </h2>
					</div>
				</div>
				<div class="partner-wrapper">
					<div class="partner-title center70">
						技术论坛
					</div>
					<div class="partner-bg-container" :style="{'background-image': `url(${require(`@/assets/images/partner-bg.png`)})`}">
						<div class="partner-list center70">
							<div class="partner-item">
								<img src="@/assets/images/icons/智能合约开发.png">
								智能合约开发
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/节点安全.png">
								节点安全
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/隐私计算.png">
								隐私计算
							</div>
						</div>
					</div>
				</div>
				<div class="partner-wrapper">
					<div class="partner-title center70">
						开源工具库
					</div>
					<div class="partner-bg-container" :style="{'background-image': `url(${require(`@/assets/images/partner-bg.png`)})`}">
						<div class="partner-list center70">
							<div class="partner-item">
								<img src="@/assets/images/icons/漏洞扫描工具.png">
								漏洞扫描工具
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/链上监控脚本.png">
								链上监控脚本
							</div>
						</div>
					</div>
				</div>
				<div class="partner-wrapper">
					<div class="partner-title center70">
						在线研讨会日历
					</div>
					<div class="partner-bg-container" :style="{'background-image': `url(${require(`@/assets/images/partner-bg.png`)})`}">
						<div class="partner-list center70">
							<div class="partner-item">
								<img src="@/assets/images/icons/EVM链重入攻击防护实战.png">
								EVM链重入攻击防护实战
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/安全漏洞攻击模拟.png">
								安全漏洞攻击模拟
							</div>
						</div>
					</div>
				</div>
				<div class="partner-wrapper">
					<div class="partner-title center70">
						会员成果展示
					</div>
					<div class="partner-bg-container"
							 :style="{'background-image': `url(${require(`@/assets/images/partner-bg.png`)})`}">
						<div class="partner-list center70">
							<div class="partner-item">
								<img src="@/assets/images/icons/技术专利.png">
								技术专利
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/安全标准提案.png">
								安全标准提案
							</div>
							<div class="partner-item">
								<img src="@/assets/images/icons/行业白皮书.png">
								行业白皮书
							</div>
						</div>
					</div>
				</div>
			</section>
    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'
    import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
    import Icon from "@/components/icon/Icon.vue";
		import NewsMixin from "@/mixins/NewsMixin";
		import Swiper from 'swiper';

		import "swiper/css/swiper.css";
		import router from "@/router";

    export default {
        name: 'About',
        components: {Icon, SectionTitle, Layout},
				mixins: [NewsMixin],
        data() {
            return {
							newsList: [],
							slidesPerView: 3,
							bannerList: [
								{
									imgUrl: require(`@/assets/images/index-zt1.png`),
									title: 'DeFi安全',
								},
								{
									imgUrl: require(`@/assets/images/index-zt2.png`),
									title: '跨链漏洞',
								},
								{
									imgUrl: require(`@/assets/images/index-zt3.png`),
									title: '钱包攻击案例',
								},
								{
									imgUrl: require(`@/assets/images/index-zt4.png`),
									title: '安全报告',
								}
							],
						}
        },
				methods: {
					toDetail(id) {
						router.push('/topics/' + id)
					}
				},
				mounted() {
					this.newsList = this.getNewsList.filter(item => item.isNews);
					if(window.innerWidth <= 850) {
						this.slidesPerView = 1;
					}
					new Swiper(".swiper-container", {
						loop: true,
						mousewheel: true,
						keyboard: true,
						slidesPerView: this.slidesPerView,
						spaceBetween: 0,
						centeredSlides: true,

						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
					});
				},
		}
</script>
<style lang="scss">
.area-2{
    .icon {
        .p-img {
            width: 64px;
            height: 64px;
        }
    }
    .more{
        display: inline-flex;
        color: #2261AA;
        img {
            width: 27px;
            height: 27px;
        }
        .i1{
            margin-left: -4px;
        }
        .i2{
            margin-left: -20px;
        }
    }
}
:deep(.slick-slider) {
	height: 100% !important;
}
:deep(.slick-list) {
	height: 100% !important;
}
.swiper-container {
	margin-top: 20px;
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;

		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		transition: 300ms;
		transform: scale(0.8);
		position: relative;
		border-radius: 8px;

		img {
			border-radius: 8px;
		}

		.con-box {
			text-align: left;
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			padding: 12px 16px;
			border-radius: 0 0 8px 8px;
			color: #fff;
			background: linear-gradient(to right, #D3001D, rgba(211, 0, 29, 0.1));
			.title {
				font-size: 20px;
			}
			.text {
				font-size: 14px;
			}
		}
		&:nth-child(2n) .con-box {
			background: linear-gradient(to right, #2350a0, rgba(35,80,160,0.1));
		}
	}
	.swiper-slide-active,.swiper-slide-duplicate-active{
		transform: scale(1);
	}
	.swiper-button-next {
		right: 0 !important;
	}
	.swiper-button-prev {
		left: 0 !important;
	}
}
.partner-title {
	font-size: 24px;
	font-weight: 700;
	color: #333;
}
.partner-bg-container {
	padding: 60px 0;
	margin: 12px 0 50px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-position: 50%;
	background-repeat: no-repeat;
	background-size: cover;
	.partner-list {
		display: flex;
		gap: 80px;
		.partner-item {
			min-width: 200px;
			background-color: #ffffff;
			padding: 20px;
			text-align: center;
			color: #000000;
			font-size: 18px;
			font-weight: bold;
			display: flex;
			align-items: center;
			gap: 4px;
			justify-content: center;
			img {
				height: 30px;
			}
		}
	}
}
h2.title {
	display: flex;
	align-items: center;
	gap: 12px;
}
span.en {
	font-size: 32px;
	color: #0d6efd;
	padding-left: 5px;
}
@media screen and (max-width: 850px) {
		.partner-bg-container {
			margin-bottom: 20px;
		}
}
</style>
